import { render } from "./ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue?vue&type=template&id=05f2e84d&scoped=true"
import script from "./ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue?vue&type=script&lang=js"
export * from "./ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue?vue&type=script&lang=js"

import "./ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue?vue&type=style&index=0&id=05f2e84d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f2e84d"]])

export default __exports__